import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { Component as ComponentContainer } from '@styles/layout';
import { TextComponent } from '@model/content';
import { americanize } from '@util/string';

interface TextProps extends ThemeProps {
  alignment?: string;
}
const Title: any = styled.h1(({ theme, alignment }: TextProps) => ({
  ...(theme.custom.typography.h2 as any),
  ...(alignment && { textAlign: alignment }),
  marginBottom: 10
}));

export const TitleContainer = ({ value, alignment }: TextComponent) => {
  const textAlign = alignment && americanize(alignment);

  return (
    <ComponentContainer>
      <Title alignment={textAlign}>{value}</Title>
    </ComponentContainer>
  );
};
